<template>
    <div class="flex items-center gap-0.5">
        <Icon
            name="hashtag"
            class="w-3.5 h-3.5 text-gray-500"
        />
        <span
            class="cursor-auto text-sm text-gray-800"
            @click.stop
        >
            {{ uniqueCode }}
        </span>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        uniqueCode: {
            type: String,
            required: true,
        },
    })
</script>
